import styled from 'styled-components'
import {media as _media} from '@modifi/ui'
import {Link} from '@modifi/router'

type mediaType = Record<string, any>

const media = _media as mediaType

export const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  overflow: hidden;
`

type StyledAType = {
  lightUpOnFocus?: boolean
}

export const StyledA = styled(Link)<StyledAType>`
  display: block;
  padding: 5px;
  margin: 20px;
  opacity: 1;
  ${media.md`
    opacity: ${({lightUpOnFocus}: {lightUpOnFocus: boolean}): string =>
      lightUpOnFocus ? '0.2' : '1'};
  `}
  transition: opacity 0.2s ease;

  &:hover,
  &:focus,
  &:active {
    opacity: 1;
  }

  > img {
    display: block;
    max-width: 100%;
    max-height: 100%;
    height: auto;
    width: auto;
  }

  ${media.smaller`
      max-width: 320px;
      margin: 15px 10px;
      > img {
        max-height: 40px;
      }
  `}
  ${media.tablet`
    margin: 20px;
  `}
`
